import { Stack } from "@mui/material"

import { BookingBanner } from "@/components"
import { useDateParam, useResortParam } from "@/hooks/useSkipassFlow"
import useWebAdminTranslations from "@/hooks/useWebAdminTranslations"
import { useDateRangeAdvisoryQuery } from "@/queries/hooks"

const DateRangeAdvisoryBanners = () => {
  const { resortExternalId } = useResortParam()
  const { startDate } = useDateParam()
  const { t } = useWebAdminTranslations()

  const { data: advisories } = useDateRangeAdvisoryQuery({
    resortExternalId,
    date: startDate,
  })

  if (!advisories?.length) return null

  return (
    <Stack spacing={2}>
      {advisories.map((advisory, index) => (
        <BookingBanner
          key={`${advisory.header}-${index}`}
          data={{
            icon: advisory.icon,
            theme: advisory.theme,
            header: t(advisory.header),
            body: t(advisory.body),
            linkName: advisory.linkName ? t(advisory.linkName) : undefined,
            linkUrl: advisory.linkUrl ? t(advisory.linkUrl) : undefined,
          }}
        />
      ))}
    </Stack>
  )
}

export default DateRangeAdvisoryBanners
